import { Link } from 'react-router-dom';
import { allCategories, getArticlesByCategory } from '@/utils/article';

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {allCategories.map((c, i) => {
        const count = getArticlesByCategory(c.slug).length;
        const isAlt = i % 2 === 1;
        return (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group relative p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors overflow-hidden"
          >
            <span className={`w-11 h-11 flex items-center justify-center rounded-lg text-xl ${isAlt ? 'bg-accent-100 text-accent-600' : 'bg-primary-50 text-primary-600'}`}>
              <i className={c.icon} />
            </span>
            <h3 className="mt-4 font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors">{c.name}</h3>
            <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{c.desc}</p>
            <div className="mt-4 flex items-center justify-between">
              <span className="text-xs text-foreground-400">{count} 篇爆料</span>
              <span className="flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                进入 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}